import PropTypes from 'prop-types';
import React from 'react';

export class ImpactTableBodyCell extends React.Component {
  static propTypes = {
    className: PropTypes.string,
  };

  // NATIONAL PARKS: Please remove this disable and try to fix it if you're here
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  render(content, extraClasses) {
    return (
      <td
        className={
          'u-ph4x u-pv3x u-tcGrayDarkest ' + (this.props.className || '')
        }
      >
        {this.props.children}
      </td>
    );
  }
}
